import { Injectable } from '@angular/core';
import { Module } from '@library/store/modules/modules.interface';
import { RoomsFacade } from '@library/store/rooms/rooms.facade';
import { SidebarFiltersService } from '@molecules/sidebar-filters/sidebar-filters.service';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { DatasetCard, GraphType } from '@pages/control-page/control-page-store.service';
import { Enums } from 'constants/Enums.constant';
import { ReplaySubject, map, switchMap } from 'rxjs';

const SupportedModules = [
  Enums.ModuleType.NAMAIN,
  Enums.ModuleType.NAMODULE1,
  Enums.ModuleType.NAMODULE2,
  Enums.ModuleType.NAMODULE3,
  Enums.ModuleType.NAMODULE4,
  Enums.ModuleType.NATHERM1,
  Enums.ModuleType.NRV,
];

@Injectable()
export class SidebarRoomService {

  roomId$ = new ReplaySubject<string>(1);
  room$ = this.roomId$.asObservable().pipe(
    switchMap(id => this.roomsFacade.getRoomById(id)),
  );

  roomModules$ = this.room$.pipe(
    switchMap(room => this.controlPageCardService.roomModules(room.id)),
    map(roomModules => roomModules.filter(m => SupportedModules.includes(m.type))),
    switchMap(modules => this.sidebarFiltersService.filterModules(modules))
  );

  constructor(
    private controlPageCardService: ControlPageCardService,
    private roomsFacade: RoomsFacade,
    private sidebarFiltersService: SidebarFiltersService,
  ) {}

  displayModuleUnreachableIcon(module: Module, modules: Module[]) {
    return this.isUnreachable(module, modules);
  }

  isUnreachable(module: Module, modules: Module[]) {
    const bridge = modules.find(m => m.id === module.bridge);
    return module.reachable === false || bridge?.reachable === false;
  }

  isSelected(card: DatasetCard, module: Module, graphType: GraphType) {
    const roomId = card?.module?.room_id ?? card?.room?.id;
    return roomId === module.room_id &&
      (card.graphType === graphType || (graphType === GraphType.THERM && card.graphType === GraphType.TEMPERATURE));
  }
}
